// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9201d677","578":"660c4735","795":"268fc330","898":"06ee9ad8"}[chunkId] + ".chunk.js";
};